var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractComponent, HelperService } from 'gp-admin-abstract';
var SpinboxComponent = /** @class */ (function (_super) {
    __extends(SpinboxComponent, _super);
    // TODO: ---------------------------------------------
    function SpinboxComponent(el, helperService) {
        var _this = _super.call(this, el) || this;
        _this.el = el;
        _this.helperService = helperService;
        /**
         * Шаг, на который будет изменяться знаечние
         *
         * @type {number}
         */
        _this.step = 1;
        /**
         * Минимальное значение
         *
         * @type {number}
         */
        _this.minValue = false;
        /**
         * Максимальное значение
         *
         * @type {number}
         */
        _this.maxValue = false;
        /**
         * Текущее значение
         *
         * @type {number}
         */
        _this.value = +_this.minValue || 0;
        /**
         * Состояние доступности компонента
         *
         * @type {boolean}
         */
        _this.disabled = false;
        /**
         * Текст ошибки
         *
         * @type {string | boolean}
         */
        _this.error = false;
        // TODO: когда появится верстка, и появится ли вообще
        _this.prefix = false;
        _this.prefixIcon = false;
        _this.postfix = false;
        _this.postfixIcon = false;
        _this.propagateChange = function (_) {
        };
        return _this;
    }
    SpinboxComponent.prototype.onKeyDown = function (event) {
        var e = event;
        if (SpinboxComponent.ALLOW_KEYS.indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && e.ctrlKey === true) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && e.ctrlKey === true) ||
            // Allow: Ctrl+V
            (e.keyCode === 86 && e.ctrlKey === true) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    };
    SpinboxComponent.prototype.writeValue = function (value) {
        if (this.validateValue(value)) {
            this.value = value;
        }
    };
    SpinboxComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    SpinboxComponent.prototype.registerOnTouched = function (fn) {
    };
    SpinboxComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    /**
     * При вводе нажатии клавиши внутри html-элемента input
     *
     * @param {KeyboardEvent} event
     */
    SpinboxComponent.prototype.onInputKeyDown = function (event) {
        var keyCode = event.which || event.keyCode;
        if (keyCode === SpinboxComponent.KEY_CODE_DOWN) {
            event.preventDefault();
            this.clickArrowDown();
        }
        else if (keyCode === SpinboxComponent.KEY_CODE_UP) {
            event.preventDefault();
            this.clickArrowUp();
        }
    };
    /**
     * Проверяем и запрещаем вводить символов больше, чем указано
     * Если вводят больше, чем можно, устанавливаем максимальное
     *
     * @param {KeyboardEvent} event
     */
    SpinboxComponent.prototype.onKeyPress = function (event) {
        if (this.value
            && (String(this.value).length === String(this.maxValue).length)
            && (!(!!this.helperService.getSelectedText()))) {
            event.preventDefault();
            if (this.value < +this.maxValue) {
                this.value = +this.maxValue;
            }
        }
    };
    /**
     * При вводе данных
     */
    SpinboxComponent.prototype.change = function () {
        this.propagateChange(this.value);
    };
    SpinboxComponent.prototype.showErrorText = function () {
        return ((typeof this.error === 'string') && !!this.error);
    };
    /**
     * Клик по стрелочке 'вверх'
     */
    SpinboxComponent.prototype.clickArrowUp = function () {
        var newVal = +this.value + this.step;
        if (this.maxValue === false || newVal <= this.maxValue) {
            this.value = newVal;
            this.propagateChange(newVal);
        }
    };
    /**
     * Клик по стрелочке 'вниз'
     */
    SpinboxComponent.prototype.clickArrowDown = function () {
        var newVal = +this.value - this.step;
        if (this.minValue === false || newVal >= this.minValue) {
            this.value = newVal;
            this.propagateChange(newVal);
        }
    };
    /**
     * При потере фокуса
     * выставлять в поле минимальное значение
     */
    SpinboxComponent.prototype.inputBlur = function () {
        this.checkValue();
    };
    SpinboxComponent.prototype.validateValue = function (value) {
        return ((this.maxValue === false) || (value <= this.maxValue))
            && ((this.minValue === false) || (value >= this.minValue));
    };
    /**
     * При вставке значений в компонент
     *
     * Нужна небольшая задержка, для получения данных после вставки
     */
    SpinboxComponent.prototype.onPaste = function () {
        var _this = this;
        setTimeout(function () {
            _this.checkValue();
        }, 1);
    };
    /**
     * Проверка значения при вставке | вводе с клавиатуры
     */
    SpinboxComponent.prototype.checkValue = function () {
        this.value = Number(this.value);
        if (String(this.value).length === 0) {
            this.value = +this.minValue;
        }
        if (String(this.value).length > String(this.maxValue).length) {
            this.value = +this.maxValue;
        }
    };
    SpinboxComponent.KEY_CODE_UP = 38;
    SpinboxComponent.KEY_CODE_DOWN = 40;
    SpinboxComponent.ALLOW_KEYS = [46, 8, 9, 27, 13, 110, 190];
    SpinboxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'gp-spinbox',
                    template: "\n<div\n  class=\"gp-spinbox {{extraClass}}\"\n  [ngClass]=\"{'gp-spinbox--filled': !!value}\"\n>\n\n  <div class=\"flex flex--content-between\">\n    <div class=\"gp-spinbox__title\">{{ title }}</div>\n    <div class=\"gp-spinbox__error\" *ngIf=\"showErrorText()\">{{ error }}</div>\n  </div>\n\n  <div class=\"pr\">\n    <input\n      type=\"number\"\n      class=\"gp-spinbox__area\"\n      [min]=\"minValue\"\n      [max]=\"maxValue\"\n      [value]=\"value\"\n      [placeholder]=\"placeholder\"\n      [disabled]=\"disabled\"\n      (blur)=\"inputBlur()\"\n      (keypress)=\"onKeyPress($event)\"\n      (keydown)=\"onInputKeyDown($event)\"\n      (paste)=\"onPaste()\"\n      [(ngModel)]=\"value\"\n      (ngModelChange)=\"change()\"\n    >\n    <div class=\"gp-spinbox__plus\" (click)=\"clickArrowUp()\"></div>\n    <div class=\"gp-spinbox__minus\" (click)=\"clickArrowDown()\"></div>\n  </div>\n\n</div>\n",
                    styles: [
                        "@charset \"UTF-8\";\n/**\n * \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435\n */\n:root {\n  --color-white: white;\n  --color-success: #00afec;\n  --color-warning: #ffb827;\n  --color-error: #f35252;\n  --color-disabled: #dbdbdb;\n  --color-black: black;\n  --color-span: #b5b5b5;\n  --color-span-second: #212121;\n  --color-bg: #f8f8f8;\n  --color-bg-second: #f8f8f8;\n  --color-bg-success: rgba(0, 175, 236, 0.1);\n  --color-bg-warning: var(--color-warning);\n  --color-bg-error: var(--color-error);\n  --color-placeholder: #b5b5b5;\n  --color-border: #dbdbdb;\n  --color-radio-border: #d3d3d3;\n  --font-roboto: 'Roboto', sans-serif;\n  --font-helvetica: 'Helvetica', sans-serif; }\n\n/**\n *\n */\n/**\n * \u0421\u0442\u0438\u043B\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430 \"gp-spinbox\"\n */\n.gp-spinbox {\n  position: relative; }\n  .gp-spinbox > .pr:after {\n    position: absolute;\n    z-index: 0;\n    top: 0.2rem;\n    right: 0.2rem;\n    bottom: 0.2rem;\n    display: block;\n    width: 2.3rem;\n    content: '';\n    border-radius: 0.3rem;\n    background-color: var(--color-white); }\n  .gp-spinbox__plus, .gp-spinbox__minus {\n    position: absolute;\n    width: 0.6rem;\n    height: 0.4rem;\n    cursor: pointer;\n    z-index: 1; }\n  .gp-spinbox__plus {\n    top: 0.2rem;\n    right: 0.2rem;\n    padding: 0.8rem 1.3rem; }\n    .gp-spinbox__plus:before {\n      content: '';\n      position: absolute;\n      display: block;\n      border-right: 0.3rem solid transparent;\n      border-bottom: 0.4rem solid #dbdbdb;\n      border-left: 0.3rem solid transparent;\n      top: 1rem;\n      right: 1rem; }\n    .gp-spinbox__plus:hover:before {\n      border-bottom-color: #b5b5b5; }\n  .gp-spinbox__minus {\n    right: 0.2rem;\n    bottom: 0.2rem;\n    padding: 0.8rem 1.3rem; }\n    .gp-spinbox__minus:hover:before {\n      border-top-color: #b5b5b5; }\n    .gp-spinbox__minus:before {\n      content: '';\n      position: absolute;\n      display: block;\n      border-top: 0.4rem solid #dbdbdb;\n      border-right: 0.3rem solid transparent;\n      border-left: 0.3rem solid transparent;\n      right: 1rem;\n      bottom: 1rem; }\n  .gp-spinbox--success input.gp-spinbox__area {\n    border-color: #00afec; }\n  .gp-spinbox--success .gp-spinbox__title {\n    color: #00afec; }\n  .gp-spinbox--error input.gp-spinbox__area {\n    border-color: #f35252; }\n  .gp-spinbox--error .gp-spinbox__title {\n    color: #f35252; }\n  .gp-spinbox--error .gp-spinbox__error {\n    display: block; }\n  .gp-spinbox--disabled .gp-spinbox__minus:hover,\n  .gp-spinbox--disabled .gp-spinbox__plus:hover {\n    cursor: not-allowed; }\n  .gp-spinbox--disabled .gp-spinbox__minus:hover:before,\n  .gp-spinbox--disabled .gp-spinbox__plus:hover:before {\n    border-top-color: #dbdbdb;\n    border-bottom-color: #dbdbdb; }\n  .gp-spinbox--disabled > .pr:after {\n    background-color: #f8f8f8;\n    cursor: not-allowed; }\n  .gp-spinbox--disabled input.gp-spinbox__area {\n    cursor: not-allowed;\n    color: #b5b5b5;\n    border-color: #dbdbdb;\n    background-color: #f8f8f8; }\n  .gp-spinbox__area {\n    font: 1.3rem/1.5rem \"Roboto\", sans-serif;\n    min-width: 18rem;\n    width: 100%;\n    padding: 1rem 1rem 1rem 1.5rem;\n    color: #212121;\n    border: 0.1rem solid #dbdbdb;\n    border-radius: 0.2rem;\n    background-color: var(--color-white); }\n  .gp-spinbox__title {\n    font: 500 1.2rem/1.4rem \"Roboto\", sans-serif;\n    margin-bottom: 0.5rem;\n    color: #b5b5b5;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n  .gp-spinbox__error {\n    font: 500 1.2rem/1.4rem \"Roboto\", sans-serif;\n    display: none;\n    color: #f35252; }\n\ninput::-webkit-input-placeholder,\ninput:-ms-input-placeholder,\ninput::placeholder {\n  color: #b5b5b5;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n"
                    ],
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: SpinboxComponent,
                            multi: true
                        }
                    ]
                },] },
    ];
    /** @nocollapse */
    SpinboxComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: HelperService, },
    ]; };
    SpinboxComponent.propDecorators = {
        'title': [{ type: Input },],
        'placeholder': [{ type: Input },],
        'step': [{ type: Input },],
        'minValue': [{ type: Input },],
        'maxValue': [{ type: Input },],
        'value': [{ type: Input },],
        'disabled': [{ type: Input },],
        'error': [{ type: Input },],
        'prefix': [{ type: Input },],
        'prefixIcon': [{ type: Input },],
        'postfix': [{ type: Input },],
        'postfixIcon': [{ type: Input },],
        'onKeyDown': [{ type: HostListener, args: ['keydown', ['$event'],] },],
    };
    return SpinboxComponent;
}(AbstractComponent));
export { SpinboxComponent };
//# sourceMappingURL=spinbox.component.js.map